export const MissionSummaryLoading = () => {
  return (
    <>
      <div className="mt-sh-30 flex h-96 animate-pulse items-center gap-2 rounded-2xl border bg-gray-200 p-5"></div>
    </>
  );
};
